import React, { useEffect } from "react";
import { connect } from 'react-redux'
import { getUnenrolledStudentInfo } from '../../../redux/actions/unenrolledStudent'
import { Col, Container, Row } from "react-bootstrap";
import CandidateInfo from "../../../components/CandidateInfo";
import Documents from '../../../components/Documents'
import StudentNews from '../../../components/StudentNews'
import Skeleton from 'react-loading-skeleton'

const UnenrolledStudentHome = ({ student, getUnenrolledStudentInfo}) => {

  const { documents, info, isLoading } = student
  useEffect(() => {
    getUnenrolledStudentInfo()
  }, [])

  return (
    <>
      <Container>
        <Row className="mt-5 mb-2">
          <Col xs={{ span: 12 }}>
            <h1>Documentos a entregar</h1>
          </Col>
        </Row>
        <hr />
        {
          isLoading 
            ? <Skeleton height={100} /> 
            : info.inscripcion && !info.inscripcion.inscrito && <StudentNews info={info} />
        }
        <Row>
          <Col xs={{ span: 12 }}>
            {
              isLoading 
                ? <Skeleton height={100} />
                : <CandidateInfo info={info} />
            }
          </Col>
        </Row>
        <Row>
          <Col style={{background: 'white' }}>
            {
              isLoading 
                ? <Skeleton height={700} />
                : <Documents documents={documents} equivalencia={info.inscripcion && info.inscripcion.equivalencia}/>
            }
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    student: state.unenrolledStudent
  }
}


const mapDispatchToProps = {
  getUnenrolledStudentInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(UnenrolledStudentHome)
